import _get from 'lodash/get';

const resultReports = _get(window, 'cccisd.appDefs.reports.list', [])
    .filter(item => item.reportTemplateHandle === 'result')
    .reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
    }, {});

const navs = [
    {
        id: 1,
        name: 'Child Trauma Screen',
        navName: 'CTS',
        measures: [
            {
                id: 1,
                name: 'Child Trauma Screen - Caregiver',
                reporter: 'Caregiver',
                reportHandle: 'cts_caregiver',
            },
            {
                id: 2,
                name: 'Child Trauma Screen - Student',
                reporter: 'Student',
                reportHandle: 'cts_student',
            },
        ],
    },
    {
        id: 2,
        name: 'CRAFFT 2.1',
        navName: 'CRAFFT 2.1',
        measures: [
            {
                id: 1,
                name: 'CRAFFT 2.1 - Student',
                reporter: 'Student',
                reportHandle: 'crafft_student',
            },
        ],
    },
    {
        id: 3,
        name: 'Delaware School Climate Survey',
        navName: 'DSCS',
        measures: [
            {
                id: 1,
                name: 'Delaware School Climate Survey - Caregiver',
                reporter: 'Caregiver',
                reportHandle: 'dscs_caregiver',
            },
            {
                id: 2,
                name: 'Delaware School Climate Survey (DSCS) - Educator',
                reporter: 'Educator',
                reportHandle: 'dscs_educator',
            },
            {
                id: 3,
                name: 'Delaware School Climate Survey (3-5) - Student',
                reporter: 'Student',
                reportHandle: 'dscs_35_student',
            },
            {
                id: 4,
                name: 'Delaware School Climate Survey (6-12) - Student',
                reporter: 'Student',
                reportHandle: 'dscs_612_student',
            },
        ],
    },
    {
        id: 4,
        name: 'Generalized Anxiety Disorder-7 Severity Measure',
        navName: 'GAD-7',
        measures: [
            {
                id: 1,
                name: 'Generalized Anxiety Disorder-7 Severity Measure (GAD-7, Age 11-17) - Student',
                reporter: 'Student',
                reportHandle: 'gad_7_student',
            },
        ],
    },
    {
        id: 5,
        name: 'Pediatric Symptom Checklist (Brief)',
        navName: 'PSC-17',
        measures: [
            {
                id: 1,
                name: 'Pediatric Symptom Checklist (PSC-17) - Caregiver',
                reporter: 'Caregiver',
                reportHandle: 'psc_caregiver',
            },
            {
                id: 2,
                name: 'Pediatric Symptom Checklist (Y-PSC-17) - Student',
                reporter: 'Student',
                reportHandle: 'ypsc_student',
            },
        ],
    },
    {
        id: 6,
        name: 'School Academic Optimism Scale',
        navName: 'SAOS',
        measures: [
            {
                id: 1,
                name: 'School Academic Optimism Scale (SAOS, Grades K-12) - Educator',
                reporter: 'Educator',
                reportHandle: 'saos_educator',
            },
            {
                id: 2,
                name: 'School Academic Optimism Scale (TAOS-E, Grades K-5) - Educator',
                reporter: 'Educator',
                reportHandle: 'taos_e_educator',
            },
            {
                id: 3,
                name: 'School Academic Optimism Scale (TAOS-S, Grades 6-12) - Educator',
                reporter: 'Educator',
                reportHandle: 'taos_s_educator',
            },
        ],
    },
    {
        id: 7,
        name: 'Screen for Child Anxiety Related Disorders',
        navName: 'SCARED',
        measures: [
            {
                id: 1,
                name: 'Screen for Child Anxiety Related Disorders (SCARED-C) - Student',
                reporter: 'Student',
                reportHandle: 'scared_student',
            },
            {
                id: 2,
                name: 'Screen for Child Anxiety Related Disorders (SCARED-P) - Caregiver',
                reporter: 'Caregiver',
                reportHandle: 'scared_caregiver',
            },
        ],
    },
    {
        id: 8,
        name: 'Student Engagement Instrument',
        navName: 'SEI',
        measures: [
            {
                id: 1,
                name: 'Student Engagement Instrument (SEI) - Student',
                reporter: 'Student',
                reportHandle: 'sei_student',
            },
            {
                id: 2,
                name: 'Student Engagement Instrument (SEI-E) - Student',
                reporter: 'Student',
                reportHandle: 'sei_e_student',
            },
        ],
    },
    {
        id: 9,
        name: 'Vanderbilt ADHD Diagnostic Rating Scale',
        navName: 'VADRS - Initial',
        measures: [
            {
                id: 1,
                name: 'Vanderbilt ADHD Diagnostic Rating Scale [Initial] - Caregiver',
                reporter: 'Caregiver',
                reportHandle: 'vadrs_caregiver',
            },
            {
                id: 2,
                name: 'Vanderbilt ADHD Diagnostic Rating Scale [Initial] - Educator',
                reporter: 'Educator',
                reportHandle: 'vadrs_educator',
            },
        ],
    },
    {
        id: 10,
        name: 'Mindful Self-Care Scale (Brief) *Welcome Onboarding Tour',
        navName: 'MSCS-BRIEF',
        measures: [
            {
                id: 1,
                name: 'Mindful Self-Care Scale - Brief',
                reporter: 'Provider',
                reportHandle: 'mscs_provider',
            },
        ],
    },
    {
        id: 11,
        name: 'Social Skills Behavioral Index (SSBI) - Full',
        navName: 'SSBI Full',
        measures: [
            {
                id: 1,
                name: 'Social Skills Behavioral Index (SSBI) [Student; Grades 6-12]',
                reporter: 'Student',
                reportHandle: 'ssbi_student_full',
            },
            {
                id: 2,
                name: 'Social Skills Behavioral Index (SSBI) [Educator; Grades K-12]',
                reporter: 'Educator',
                reportHandle: 'ssbi_educator_full',
            },
            {
                id: 3,
                name: 'Social Skills Behavioral Index (SSBI) [Caregiver; Grades K-12]',
                reporter: 'Caregiver',
                reportHandle: 'ssbi_caregiver_full',
            },
        ],
    },
    {
        id: 12,
        name: 'Social Skills Behavioral Index (SSBI) - Social Emotional Skills (SES) Scale',
        navName: 'SSBI SEL Skills',
        measures: [
            {
                id: 1,
                name: 'Social Skills Behavioral Index (SSBI) - Social Emotional Skills (SES) Scale [Student; Grades 6-12]',
                reporter: 'Student',
                reportHandle: 'ssbi_student_ses',
            },
            {
                id: 2,
                name: 'Social Skills Behavioral Index (SSBI) - Social Emotional Skills (SES) Scale [Educator; Grades K-12]',
                reporter: 'Educator',
                reportHandle: 'ssbi_educator_ses',
            },
            {
                id: 3,
                name: 'Social Skills Behavioral Index (SSBI) - Social Emotional Skills (SES) Scale [Caregiver; Grades K-12]',
                reporter: 'Caregiver',
                reportHandle: 'ssbi_caregiver_ses',
            },
        ],
    },
    {
        id: 13,
        name: 'Social Skills Behavioral Index (SSBI) - Behavioral Functioning (BF) Scale',
        navName: 'SSBI Behavior',
        measures: [
            {
                id: 1,
                name: 'Social Skills Behavioral Index (SSBI) - Behavioral Functioning (BF) Scale [Student; Grades 6-12]',
                reporter: 'Student',
                reportHandle: 'ssbi_student_bf',
            },
            {
                id: 2,
                name: 'Social Skills Behavioral Index (SSBI) - Behavioral Functioning (BF) Scale [Educator; Grades K-12]',
                reporter: 'Educator',
                reportHandle: 'ssbi_educator_bf',
            },
            {
                id: 3,
                name: 'Social Skills Behavioral Index (SSBI) - Behavioral Functioning (BF) Scale [Caregiver; Grades K-12]',
                reporter: 'Caregiver',
                reportHandle: 'ssbi_caregiver_bf',
            },
        ],
    },
    {
        id: 14,
        name: 'Social Skills Behavioral Index (SSBI) - Peer Problems (PB) Scale',
        navName: 'SSBI Peer',
        measures: [
            {
                id: 1,
                name: 'Social Skills Behavioral Index (SSBI) - Peer Problems (PB) Scale [Student; Grades 6-12]',
                reporter: 'Student',
                reportHandle: 'ssbi_student_pp',
            },
            {
                id: 2,
                name: 'Social Skills Behavioral Index (SSBI) - Peer Problems (PB) Scale [Educator; Grades K-12]',
                reporter: 'Educator',
                reportHandle: 'ssbi_educator_pp',
            },
            {
                id: 3,
                name: 'Social Skills Behavioral Index (SSBI) - Peer Problems (PB) Scale [Caregiver; Grades K-12]',
                reporter: 'Caregiver',
                reportHandle: 'ssbi_caregiver_pp',
            },
        ],
    },
    {
        id: 15,
        name: 'Social Skills Behavioral Index (SSBI) - Academic Performance (AP) Scale',
        navName: 'SSBI Academic',
        measures: [
            {
                id: 1,
                name: 'Social Skills Behavioral Index (SSBI) - Academic Performance (AP) Scale [Student; Grades 6-12]',
                reporter: 'Student',
                reportHandle: 'ssbi_student_ap',
            },
            {
                id: 2,
                name: 'Social Skills Behavioral Index (SSBI) - Academic Performance (AP) Scale [Educator; Grades K-12]',
                reporter: 'Educator',
                reportHandle: 'ssbi_educator_ap',
            },
            {
                id: 3,
                name: 'Social Skills Behavioral Index (SSBI) - Academic Performance (AP) Scale [Caregiver; Grades K-12]',
                reporter: 'Caregiver',
                reportHandle: 'ssbi_caregiver_ap',
            },
        ],
    },
    {
        id: 16,
        name: 'Alcohol Use Disorders Identification Test',
        navName: 'AUDIT',
        measures: [
            {
                id: 1,
                name: 'Alcohol Use Disorders Identification Test (AUDIT) [Student; Grades 9-12]',
                reporter: 'Student',
                reportHandle: 'audit_student',
            },
        ],
    },
    {
        id: 17,
        name: 'Center for Epidemiological Studies Depression Scale for Children',
        navName: 'CES-DC',
        measures: [
            {
                id: 1,
                name: 'Center for Epidemiological Studies Depression Scale for Children (CES-DC) [Student; Grades 1-12]',
                reporter: 'Student',
                reportHandle: 'cesdc_student',
            },
        ],
    },
    {
        id: 18,
        name: 'Center for Epidemiological Studies Depression Scale for Children',
        navName: 'DSRS-C',
        measures: [
            {
                id: 1,
                name: 'Depression Self-Rating Scale for Children (DSRS-C) [Student; Grades 3-9]',
                reporter: 'Student',
                reportHandle: 'dsrsc_student',
            },
        ],
    },
    {
        id: 19,
        name: 'Student Subjective Wellbeing Questionnaire',
        navName: 'SSWQ',
        measures: [
            {
                id: 1,
                name: 'Student Subjective Wellbeing Questionnaire (SSWQ) [Student; Grades 6-12]',
                reporter: 'Student',
                reportHandle: 'sswq_student',
            },
        ],
    },
    {
        id: 20,
        name: "Students' Life Satisfaction Scale",
        navName: 'SLSS',
        measures: [
            {
                id: 1,
                name: "Students' Life Satisfaction Scale (SLSS) [Student; Grades 3-12]",
                reporter: 'Student',
                reportHandle: 'slss_student',
            },
        ],
    },
    {
        id: 21,
        name: 'Vanderbilt ADHD Diagnostic Rating Scale Follow Up',
        navName: 'VADRS - Follow Up',
        measures: [
            {
                id: 1,
                name: 'Vanderbilt ADHD Diagnostic Rating Scale Follow Up (VADRS - Follow Up) [Caregiver; Grades 1-7]',
                reporter: 'Caregiver',
                reportHandle: 'vadrs_fu_caregiver',
            },
            {
                id: 2,
                name: 'Vanderbilt ADHD Diagnostic Rating Scale Follow Up (VADRS - Follow Up) [Educator; Grades 1-7]',
                reporter: 'Educator',
                reportHandle: 'vadrs_fu_educator',
            },
        ],
    },
    {
        id: 22,
        name: 'Zoo U',
        navName: 'Zoo U',
        measures: [
            {
                id: 1,
                name: 'Zoo U [Student; K-5]',
                reporter: 'Student',
                reportHandle: 'zoou_student',
            },
        ],
    },
    {
        id: 23,
        name: 'School Climate Measure',
        navName: 'SCM',
        measures: [
            {
                id: 1,
                name: 'School Climate Measure [Student; Grades 6-12]',
                reporter: 'Student',
                reportHandle: 'scm_student',
            },
        ],
    },
    {
        id: 24,
        name: 'The Child PTSD Symptom Scale',
        navName: 'CPSS',
        measures: [
            {
                id: 1,
                name: 'The Child PTSD Symptom Scale',
                reporter: 'Student',
                reportHandle: 'cpss_student',
            },
        ],
    },
    {
        id: 25,
        name: 'The Child PTSD Symptom Scale with Trauma Screen',
        navName: 'CPSST',
        measures: [
            {
                id: 1,
                name: 'The Child PTSD Symptom Scale with Trauma Screen',
                reporter: 'Student',
                reportHandle: 'cpsst_student',
            },
        ],
    },
    {
        id: 26,
        name: 'The SNAP-IV Parent and Teacher Rating Scale 90',
        navName: 'SNAP-IV',
        measures: [
            {
                id: 1,
                name: 'The SNAP-IV Parent and Teacher Rating Scale 90 [Caregiver; Grades K-12]',
                reporter: 'Caregiver',
                reportHandle: 'snapiv_caregiver_full',
            },
            {
                id: 2,
                name: 'The SNAP-IV Parent and Teacher Rating Scale 90 [Educator; Grades K-12]',
                reporter: 'Educator',
                reportHandle: 'snapiv_educator_full',
            },
        ],
    },
    {
        id: 27,
        name: 'The SNAP-IV Parent and Teacher Rating Scale 18',
        navName: 'SNAP-IV - Abbreviated',
        measures: [
            {
                id: 1,
                name: 'The SNAP-IV Parent and Teacher Rating Scale 18 [Caregiver; Grades K-12]',
                reporter: 'Caregiver',
                reportHandle: 'snapiv_caregiver_abb',
            },
            {
                id: 2,
                name: 'The SNAP-IV Parent and Teacher Rating Scale 18 [Educator; Grades K-12]',
                reporter: 'Educator',
                reportHandle: 'snapiv_educator_abb',
            },
        ],
    },
];

const getNavs = (surveyIds = [], reporterPawnIds = [], student) => {
    let idCounter = 1;
    const result = navs
        .map(nav => ({
            ...nav,
            measures: nav.measures
                .filter(measure => {
                    const reportSurveyIds = resultReports[measure.reportHandle]?.reportTemplateSettings?.surveyIds;
                    return reportSurveyIds && reportSurveyIds.some(id => surveyIds.includes(id));
                })
                .reduce((arr, measure) => {
                    const contactType = measure.reporter;
                    if (!student.reporters[contactType]) {
                        return arr;
                    }

                    for (const contact of student.reporters[contactType]) {
                        idCounter++;
                        if (reporterPawnIds.includes(contact.pawnId)) {
                            arr.push({
                                ...measure,
                                id: idCounter,
                                reporterLabel: contact.name
                                    ? `${measure.reporter} (${contact.name})`
                                    : measure.reporter,
                                reporterName: contact.name,
                                pawnId: contact.pawnId,
                            });
                        }
                    }

                    return arr;
                }, []),
        }))
        .filter(nav => nav.measures.length > 0);

    return result;
};

export default getNavs;
